import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/index";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <div style={{ width: "100%", height: "100%" }}>
        <div
        // style={{
        //   zoom: 0.8,
        //   transformOrigin: "top left",
        // }}
        >
          <App />
        </div>
      </div>
    </BrowserRouter>
  </Provider>
);
